<template>
  <h2>Your NFT Collection</h2>
  <div>
    <collection
      v-for="nft in listedNFTs"
      :key="nft.id"
      :nftId="nft.id"
      :nftTitle="nft.title"
      :nftImg="nft.img"
      :nftPrice="nft.price"
    ></collection>
  </div>
</template>

<script>
import Collection from "./Collection.vue";
export default {
  inject: ["listedNFTs"],
  components: {
    Collection,
  },
};

</script>

<style scoped>
div {
  background: white;
  padding: 10px;
  margin: 8px;
  text-align: center;
  font-family: Arial, Helvetica, sans-serif;
}

h2 {
  text-align: center;
  font-family: Arial, Helvetica, sans-serif;
  background-color: darkcyan;
  padding: 1rem;
  color:white
}
</style>